import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Btn from "../../components/common/Btn";
import { common } from "../../../../common/api";
import { mobileTypeFn } from "../logic";
import SignIn from "../../pages/sign/SignIn";
import FindPass from "../../pages/sign/FindPass";

const SignUp = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const [isApple, setIsApple] = useState(false);
  const params = new URL(document.location).searchParams;
  const firebaseToken = params.get("firebaseToken");

  // useEffect(() => {
  //   const iphoneLoad = async () => {
  //     const phoneType = mobileTypeFn();
  //     if (phoneType === "iphone") {
  //       //아이폰 특정 버전일때 sns 로그인 버튼제거, 아이폰앱 새로 올릴때 사용, 앱올라간후에는 제거
  //       let appVersion = await window.flutter_inappwebview.callHandler(
  //         "getIosVersion"
  //       );
  //       if (appVersion === "2.0.17") {
  //         setShowSns(false);
  //       }
  //     }
  //   };
  //   iphoneLoad();
  // }, []);

  useEffect(() => {
    if (firebaseToken !== null && firebaseToken !== "") {
      //token 있을때
      window.sessionStorage.setItem("token", firebaseToken);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const iphoneLoad = async () => {
      const phoneType = mobileTypeFn();
      if (phoneType === "iphone") {
        setIsApple(true);
      }
    };
    iphoneLoad();
  }, []);

  const onLoginGoogle = () => {
    // Redirect to Google OAuth endpoint (uses API_BASE_URL from .env)
    window.location.href = `${common.baseURL}auth/google`;
  };

  const onLoginApple = () => {
    // Keep Apple login for iOS users
    window.flutter_inappwebview?.callHandler("apple_login");
  };

  return (
    <div className="flex flex-col h-screen place-content-center">
      <img
        src="/images/mobile/home/signup_txt.svg"
        className="mx-auto"
        alt="Healiary"
      />
      <SignIn />
      <div className="flex justify-between mx-6 my-5">
        <p
          className="text-base font-semibold leading-7 tracking-tight text-neutral-600 cursor-pointer"
          onClick={() => navigate("/findpass")}
        >
          {t('login.forgot_password')}
        </p>
        <div className="flex flex-row gap-1">
          <p
            className="text-base font-semibold leading-7 tracking-tight text-neutral-600 cursor-pointer"
            onClick={() => navigate(`/emailsignup`)}
          >
            {t('signup.email_signup')}
          </p>
          <img src="./images/mobile/icon/login/arrow_right.svg" alt="arrow" />
        </div>
      </div>
      <div className="flex items-center gap-2 mx-6 mt-10 mb-3">
        <p className="h-[0.5px] w-full bg-gray_160"></p>
        <p className="font-bold shrink-0 text-gray_160">{t('signup.or_signup_with')}</p>
        <p className="h-[0.5px] w-full bg-gray_160"></p>
      </div>

      <div className="mx-6 flex flex-col gap-[10px]">
        {/* Google OAuth Login */}
        <button
          onClick={onLoginGoogle}
          className="flex items-center justify-center gap-3 w-full py-4 bg-white border-2 border-gray-300 rounded-xl font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {t('signup.continue_with_google')}
        </button>

        {/* Apple ID Login (iOS only) */}
        {isApple && (
          <button
            onClick={onLoginApple}
            className="flex items-center justify-center gap-3 w-full py-4 bg-[#202020] border border-[#202020] rounded-xl font-semibold text-white hover:bg-[#000000] transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            Continue with Apple
          </button>
        )}
      </div>
    </div>
  );
};

export default SignUp;
